var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M35.475 0H5.525C2.474 0 0 2.474 0 5.525v29.95C0 38.526 2.474 41 5.525 41h14.771l.025-14.651h-3.806c-.495 0-.896-.4-.898-.895l-.018-4.723c-.002-.497.4-.901.898-.901h3.8v-4.563c0-5.296 3.234-8.18 7.958-8.18h3.876c.496 0 .898.402.898.899v3.982c0 .496-.402.898-.897.898h-2.38c-2.568 0-3.066 1.222-3.066 3.013v3.95h5.645c.538 0 .956.47.892 1.005l-.56 4.722c-.053.452-.436.793-.891.793h-5.06L26.685 41h8.79C38.525 41 41 38.526 41 35.475V5.525C41 2.474 38.526 0 35.475 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1d1e27c8c257d34484176c2088cd0c26.svg";
export { ForwardRef as ReactComponent };